"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingIntervalSelector = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../../atoms");

var _TRCToggle = _interopRequireDefault(require("../../../TRCToggle"));

require("./BillingIntervalSelector.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Billing Interval Selector
var BillingIntervalSelector = function BillingIntervalSelector(_ref) {
  var showUserInfo = _ref.showUserInfo,
      showMonthlyBreakdown = _ref.showMonthlyBreakdown,
      upgradeeFullName = _ref.upgradeeFullName,
      upgradeeContact = _ref.upgradeeContact,
      monthlyPrice = _ref.monthlyPrice,
      monthlyBillingPrompt = _ref.monthlyBillingPrompt,
      yearlyPrice = _ref.yearlyPrice,
      yearlyBillingPrompt = _ref.yearlyBillingPrompt,
      selectedBillingInterval = _ref.selectedBillingInterval,
      setSelectedBillingInterval = _ref.setSelectedBillingInterval,
      yearlyPriceBreakdown = _ref.yearlyPriceBreakdown,
      monthlyPriceBreakdown = _ref.monthlyPriceBreakdown;
  var billingIntervalPrompt = selectedBillingInterval === "monthly" ? monthlyBillingPrompt : yearlyBillingPrompt;

  var handleOnChangeBillingInteval = function handleOnChangeBillingInteval() {
    var newInterval = selectedBillingInterval === "yearly" ? "monthly" : "yearly";

    if (typeof setSelectedBillingInterval === "function") {
      setSelectedBillingInterval(newInterval);
    }
  };

  var offColor = _atoms.Color.Grey3;
  var onColor = _atoms.Color.Black;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "BillingIntervalSelector",
    padding: "4 4",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%"
  }, showUserInfo && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    type: _atoms.Label.Type.Header3
  }, "Upgrade ", /*#__PURE__*/_react.default.createElement("b", null, upgradeeFullName ? upgradeeFullName : "to Trace iD+")), upgradeeContact && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    type: _atoms.Label.Type.SmallBody,
    color: _atoms.Color.Grey1,
    content: upgradeeContact
  }))), showMonthlyBreakdown && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    center: true,
    type: _atoms.Label.Type.Heading3
  }, selectedBillingInterval === "yearly" ? yearlyPriceBreakdown : monthlyPriceBreakdown), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    alignItems: "center",
    justifyContent: "space-around",
    marginTop: "4",
    marginBottom: "4",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    color: selectedBillingInterval === "monthly" ? onColor : offColor,
    type: _atoms.Label.Type.Body
  }, monthlyPrice), /*#__PURE__*/_react.default.createElement(_TRCToggle.default, {
    trkAction: "Toggle Plan",
    checked: selectedBillingInterval === "yearly",
    onToggle: handleOnChangeBillingInteval
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    color: selectedBillingInterval === "yearly" ? onColor : offColor,
    type: _atoms.Label.Type.Body
  }, yearlyPrice)), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    color: _atoms.Color.Grey1,
    type: _atoms.Label.Type.SmallBody
  }, billingIntervalPrompt)));
};

exports.BillingIntervalSelector = BillingIntervalSelector;
BillingIntervalSelector.defaultProps = {
  showUserInfo: true,
  showMonthlyBreakdown: false,
  selectedBillingInterval: "yearly",
  monthlyBillingPrompt: "*Billed once a month",
  yearlyBillingPrompt: "*Billed once a year",
  monthlyPrice: "$9.99 Monthly",
  monthlyPriceBreakdown: "$9.99 / month",
  yearlyPrice: "$99 Yearly",
  yearlyPriceBreakdown: "$8.25 / month"
};